'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HeaderContainer = require('../../containers/common/HeaderContainer');

var _HeaderContainer2 = _interopRequireDefault(_HeaderContainer);

var _PropTypes = require('../../validators/common/PropTypes');

var _ContactUs = require('./ContactUs');

var _ContactUs2 = _interopRequireDefault(_ContactUs);

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders multiple pages within a form in a wizard-style display.
 * @extends {Component}
 */
var MultiFormComponent = function (_React$Component) {
  _inherits(MultiFormComponent, _React$Component);

  function MultiFormComponent() {
    _classCallCheck(this, MultiFormComponent);

    return _possibleConstructorReturn(this, (MultiFormComponent.__proto__ || Object.getPrototypeOf(MultiFormComponent)).apply(this, arguments));
  }

  _createClass(MultiFormComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.setNumPages(_react2.default.Children.count(this.props.children));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'index' },
        _react2.default.createElement(
          'div',
          { className: 'ingle-form container main-div div-container ' + this.props.productStyle },
          _react2.default.createElement(_HeaderContainer2.default, _extends({ title: this.props.headerTitle }, this.props.headerProps)),
          _react2.default.createElement(
            'div',
            { className: 'ingle-form-body' },
            _react2.default.Children.map(this.props.children, function (element, index) {
              return _this2.props.navigation.currentPage === index + 1 && element;
            })
          )
        ),
        (0, _url2.default)('contact_form') && _react2.default.createElement(_ContactUs2.default, this.props)
      );
    }
  }]);

  return MultiFormComponent;
}(_react2.default.Component);

MultiFormComponent.propTypes = {
  children: _PropTypes.REACT_CHILDREN.isRequired,
  headerTitle: _react2.default.PropTypes.string.isRequired,
  headerProps: _react2.default.PropTypes.object,
  navigation: _react2.default.PropTypes.object.isRequired,
  setNumPages: _react2.default.PropTypes.func.isRequired,
  productStyle: _react2.default.PropTypes.string
};
exports.default = MultiFormComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/MultiFormComponent.jsx
// module id = 1666
// module chunks = 0